module.exports = __webpack_public_path__ + "assets/male.a20659ab.png";